import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import VueApexCharts from 'vue-apexcharts';
import ToastPlugin from './plugins/toast';
import LoaderPlugin from './plugins/loader';
import store from './store/store';
import { router } from './router/router';

import App from './App.vue';


Vue.config.performance = true;

Vue.use(VueRouter);
Vue.use(Vuetify, {
  theme: {
    primary: '#0f1e32',
    secondary: '#e57373',
    accent: '#9c27b0',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50',
  },
});
Vue.use(VueApexCharts);
Vue.use(ToastPlugin);
Vue.use(LoaderPlugin);
Vue.component('apexchart', VueApexCharts);

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
